import { useState, useEffect } from "react";
import { OrderStatus } from "../../../common/enums/OrderStatus";

export function useOrderStatusRedirect(
  status: number | undefined,
  returnUrl: string,
  amountDue?: number,
) {
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    if (status === OrderStatus.InProgress || status === OrderStatus.Completed) {
      if ((amountDue ?? 0) > 0) return;
      setIsRedirecting(true);
      window.location.href = returnUrl;
    }
  }, [status, amountDue]);

  return { isRedirecting };
}
